import { useSlice } from '@/composables/UseSlice';
import _ from 'lodash';
import { defineStore } from 'pinia';
import { computed } from 'vue';

export const useAlgoliaPrismicStore = defineStore('algolia-prismic', () => {
  const { slices } = useSlice('algolia', 'algolia');
  const explanations = computed(() =>
    _.mapKeys(slices.value.filter_explanation?.items, 'identifier')
  );

  return {
    explanations,
  };
});
